<template>
  <div>
    <h1>NuxtLayout 默认模板，可以添加在所有页面，也可单独添加</h1>
    <slot />
  </div>
</template>
